import { hasRoles } from 'js/security'

/** Renders if authenticated user has any of the permissions provided (if provided) and any of the profile provided (if provided) */
export const RenderIfAuthorized = ({ roles = [], children }) => {
  return <>{hasRoles(roles) && children}</>
}
